
import React, { Component } from 'react'
import './calculator.css'
import { Link, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import * as actions from '../../../actions/index'
import Cookies from 'js-cookie'
//images
import CalcImg from '../../../images/calculator.png'

import Width from '../../../images/icons/width.svg'
import Length from '../../../images/icons/length.svg'
import Height from '../../../images/icons/height.svg'

import WidthReg from '../../../images/original/9.svg'
import LengthReg from '../../../images/original/8.svg'
import HeightReg from '../../../images/original/10.svg'
import BlueArrow from '../../../images/original/16.svg'

import WidthMako from '../../../images/mako/7.svg'
import LengthMako from '../../../images/mako/8.svg'
import HeightMako from '../../../images/mako/9.svg'
import LightBlueArrow from '../../../images/mako/4.svg'

import RedArrow from '../../../images/icons/redarrow.svg'
import Gps2 from '../../../images/icons/gps2.svg'
//components
import ImageComponent from '../../globals/ImageComponent/ImageComponent'
import InnerNavigation from '../../globals/InnerNavigation/InnerNavigation'
//img
import HeaderPic from '../../../images/calculator.png'
//config
import {HOST_NAME} from '../../../configs/configs'
//texts
import * as Hebrew from '../../../texts/hebrew'

class Calculator extends Component {

    constructor(props) {
        super(props)

        this.state = {
            length: this.props.levels.selectedLevelOne.x || 0,
            width: this.props.levels.selectedLevelOne.y || 0,
            height: this.props.levels.selectedLevelOne.z || 0,
            typeOfMechiron: '',
        }

        this.length =  this.props.levels.selectedLevelOne.x || 0
        this.width =  this.props.levels.selectedLevelOne.y || 0
        this.height =  this.props.levels.selectedLevelOne.z || 0
    }

    
    componentWillMount() {
     
        this.getLevelsOnDirectUrlMount()
        let typeOfMechiron = Cookies.get(HOST_NAME)
        this.setState({typeOfMechiron})
    }

    componentWillReceiveProps(nextProps) {
        let levelOne
        if(nextProps.levels.levelOnes !== this.props.levels.levelOnes && nextProps.levels.levelOnes.length > 0)
        levelOne = nextProps.levels.levelOnes.find(level=>{
            return level.level_one_id === this.props.match.params.levelOneId
        })
        if(levelOne)
        this.props.initUserCartRoom(levelOne,this.props.userCart)
    }

    getLevelsOnDirectUrlMount = async() => {
        let levelOnesInit = this.props.levels.levelOnes
        if(Object.keys(levelOnesInit).length === 0 && levelOnesInit.constructor === Object) {
            this.props.saveVendors()
            await this.props.saveLevelOnes()
            
        }

        let levelTwosInit = this.props.levels.levelTwos
        if(Object.keys(levelTwosInit).length === 0 && levelTwosInit.constructor === Object) {
            if(this.props.levels.levelOnes.length >0)
            this.props.levels.levelOnes.filter(async(item)=>{
                if (item.level_one_id === this.props.match.params.levelOneId) {
                    await this.props.saveSelectedLevelOneItem(item)
                }
            })
        }

        this.setState({
            length: this.props.levels.selectedLevelOne.x || 0,
            width: this.props.levels.selectedLevelOne.y || 0,
            height: this.props.levels.selectedLevelOne.z || 0
        })

        this.length =  this.props.levels.selectedLevelOne.x || 0
        this.width =  this.props.levels.selectedLevelOne.y || 0
        this.height =  this.props.levels.selectedLevelOne.z || 0
    }

    
    

    setValues = (name, value) => {
        let newValue = value
        if (typeof value === 'number') {
            newValue = value.toFixed(1)
        }
        newValue = Number(newValue)

        if (newValue < 0) {
            this.setState({ [name]: 0 },()=>{
                this.props.setMeasurements(this.state.length,this.state.width,this.state.height)
            })
        } else if (newValue > 999) {
            this.setState({ [name]: 999 },()=>{
                this.props.setMeasurements(this.state.length,this.state.width,this.state.height)
            })
        } else if (!newValue) {
            this.setState({ [name]: '' },()=>{
                this.props.setMeasurements(this.state.length,this.state.width,this.state.height)
            })
        } else {
            this.setState({ [name]: newValue },()=>{
                this.props.setMeasurements(this.state.length,this.state.width,this.state.height)
            })
        }
    }

    focusHandler = (e) => {
        this[e.target.name] = this.state[e.target.name]
        this.setState({
            [e.target.name] : ''
        })
    }

    blurHandler = (e) => {
        if(!this.state[e.target.name]) {
            this.setState({
                [e.target.name]: this[e.target.name]
            })
        }
    }


    CheckMobileOrTablet = () => {
        var check = false;
        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
        return check;
    }

    render() {
        const { lang } = this.props
        const { selectedLevelOne } = this.props.levels
        const {typeOfMechiron} = this.state
        let mobileOrTablet = this.CheckMobileOrTablet()

        return (
            <div className="calculator">

                <div className="cart__heading">
                   <ImageComponent src={HeaderPic} alt="calculator"/>
                   <div>
                        <h1>
                           {selectedLevelOne.name}
                        </h1>
                   </div>
                </div>
                {/* <b style={{fontWeight:'bold',color:'black',margin:'0 1px'}}> </b> */}
                <section>
                    <h6>התאימו את מידות החדר למידות שלכם לקבלת אומדן עלות.</h6>
                    {/* <p>{lang.sectionDisclaimer}</p>
                    <p>{lang.sectionDisclaimer2}</p> */}

                    <div className="calculator__input">
                        <label htmlFor="length"></label>
                        <aside>{lang.inputLength}</aside>
                        <div>
                            <img src={typeOfMechiron === 'ace' ? Length: typeOfMechiron === 'mako' ? LengthMako:LengthReg} alt="length" />
                            <input type="number" id="length" value={this.state.length} name="length" onChange={(e) => { this.setValues(e.target.name, e.target.value) }} onFocus={(e)=>{this.focusHandler(e)}} onBlur={(e)=>{this.blurHandler(e)}}/>
                            <p>{lang.SQmeters}</p>
                        </div>

                        {
                            !mobileOrTablet ?
                                <div>
                                    <span>
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('length', this.state.length + 1) }} />
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('length', this.state.length - 1) }} />
                                    </span>
                                </div>
                                :
                                <div style={{background:'transparent'}}></div>
                        }

                    </div>

                    <div className="calculator__input">
                        <label htmlFor="width"></label>
                        <aside>{lang.inputWidth}</aside>
                        <div>
                            <img src={typeOfMechiron === 'ace' ? Width: typeOfMechiron === 'mako' ? WidthMako:WidthReg} alt="width" />
                            <input type="number" id="width" value={this.state.width} name="width" onChange={(e) => { this.setValues(e.target.name, e.target.value) }} onFocus={(e)=>{this.focusHandler(e)}} onBlur={(e)=>{this.blurHandler(e)}}/>
                            <p>{lang.SQmeters}</p>
                        </div>
                        {
                            !mobileOrTablet ?
                                <div>
                                    <span>
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('width', this.state.width + 1) }} />
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('width', this.state.width - 1) }} />
                                    </span>
                                </div>
                                :
                                <div style={{background:'transparent'}}></div>
                        }
                    </div>

                    <div className="calculator__input" htmlFor="height">
                        <label htmlFor="height"></label>
                        <aside>{lang.inputHeight}</aside>
                        <div>
                            <img src={typeOfMechiron === 'ace' ? Height: typeOfMechiron === 'mako' ? HeightMako:HeightReg} alt="height" />
                            <input type="number" id="height" value={this.state.height} name="height" onChange={(e) => { this.setValues(e.target.name, e.target.value) }} onFocus={(e)=>{this.focusHandler(e)}} onBlur={(e)=>{this.blurHandler(e)}}/>
                            <p>{lang.meters}</p>
                        </div>
                        {
                            !mobileOrTablet ?
                                <div>
                                    <span>
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('height', this.state.height + 1) }} />
                                        <img src={typeOfMechiron === 'ace' ? RedArrow: typeOfMechiron === 'mako' ? LightBlueArrow:BlueArrow} alt="arrow" onClick={() => { this.setValues('height', this.state.height - 1) }} />
                                    </span>
                                </div>
                                :
                                <div style={{background:'transparent'}}></div>
                        }
                    </div>


                    {this.props.desktop != null && this.props.desktop  ?
                        <Link to={'/calculator/' + this.props.levels.selectedLevelOne.level_one_id + '/room'}><button className="button__red" onClick={()=>{this.props.disActivateCurtain()}}><span>{lang.btnContinue}</span></button></Link>
                        :
                        <Link to={'/calculator/' + this.props.match.params.levelOneId  + '/room'}><button  className="button__red"><span>{lang.btnContinue}</span></button></Link>
                    }
                </section>

                <p>מופעל על ידי המחירון של רמדור</p>
                <p>המחירים לאומדן בלבד וכוללים מע״מ. טל״ח.</p>
                
            </div>
        );
    }
}


function stateToProps({ levels,userCart }) {
    return { levels,userCart }
}
  
export default withRouter(connect(stateToProps, actions)(Calculator))